/** @jsx jsx */
import { FC, Fragment } from 'react';
import { jsx } from '@emotion/core';
import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import CancelButton from 'features/CancelButton';

const LoyaltyNumberError: FC = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();

  const content = (
    <Fragment>
      <div>{tMdMultiline(`home.loyaltyNumber.error.message`)}</div>
    </Fragment>
  );

  return (
    <SimpleMessagePage
      headerTitle={'home.loyaltyNumber.error.title'}
      message={content}
    >
      <CancelButton />
    </SimpleMessagePage>
  );
};

export default LoyaltyNumberError;
